/** Created by azhou on 2019/2/15.*/
<template>
  <div :id="eleId" :style="{'height':eleHeight+'px'}"></div>
</template>

<script>
  export default {
    name: 'BMap',
    props: {
      eleId: {                        //创建地图挂载DOM的id
        type: String,
        default: 'BMap'
      },
      eleHeight: {                    //地图高度
        type: String,
        default: '200'
      },
      markPoint: {                    //创建marker的标记数组
        type: Array,
        default () {
          return [
            {lng: 120.206194, lat: 30.291275}
          ]
        }
      },
      suggestId: {                     //自动完成对象的目标input id值
        type: String,
        default: ''
      },
      MapArea: {                       //根据传入的省市区地址信息设置地图范围显示
        type: Object,
      },
      allowDrag: {                    //是否允许地图拖拽
        type: Boolean,
        default: false
      },
      WheelZoom: {                    //是否允许滚轮缩放
        type: Boolean,
        default: false
      },
      nip: {                    //是否允许滚轮缩放
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        BMap: '',
        marker:'',
        Point:'',
      }
    },
    watch: {
      'MapArea': 'setAddressToPoint',
      'markPoint': 'markPointFun',
      //开启鼠标滚轮缩放
      WheelZoom (newVal) {
        this.BMap.enableScrollWheelZoom(newVal)
      },
      allowDrag(){
        if(this.allowDrag){
          this.marker.enableDragging()
        }else{
          this.marker.disableDragging();
          this.BMap.clearOverlays()
            //创建新的maker,这里主要是单maker传入时根据地址变更改变maker的位置
            this.markPointFun([{
              ...this.markPoint[0],
          }]);
        }
        
      }
    },
    mounted () {
      this.initMap();
      //当prop传入的值没有发生变化时，组件被重新创建后需要再次赋值
      if (this.MapArea && this.MapArea.province) this.setAddressToPoint();
      this.markPointFun(this.markPoint);
      this.BMap.enableScrollWheelZoom(this.WheelZoom)
    },
    methods: {
      /*创建百度地图组件*/
      initMap () {
        this.BMap = new BMap.Map(this.eleId)
        this.BMap.addControl(new BMap.MapTypeControl())
        this.BMap.addControl(new BMap.NavigationControl())  //添加默认缩放平移控件
        this.BMap.enableScrollWheelZoom(this.WheelZoom)
        if (this.suggestId) this.createACObj();           //创建自动完成对象
      },
      /*在地图标记地址*/
      markPointFun (newVal) {
        console.log(newVal);
        //批量添加marker
        newVal.forEach((v, index) => {
          this.Point=v;
          let myIcon = new BMap.Icon(v.IconPng, new BMap.Size(32, 32))
          let point = new BMap.Point(v.lng, v.lat)
          // 创建标注对象并添加到地图
          this.marker = new BMap.Marker(point, { icon: myIcon })
          // 创建信息窗口对象
          // let infoWindow = this.createInfoDom(obj);
          this.BMap.addOverlay(this.marker)
          if (this.allowDrag) {                               //开启标注可拖拽
            this.marker.enableDragging()
          }
          this.marker.addEventListener('dragend', e => {
              //清除已有覆盖物
              this.BMap.clearOverlays(this.marker)
              this.$emit('dragMarker', { lng: e.point.lng, lat: e.point.lat })
          })
          //将marker数组的第一个值设置为默认marker
          if (index === 0) {
            this._defaultMaker = this.marker
            this.BMap.centerAndZoom(point, 15)
          }
        })
      },
      /*建立自动完成对象,根据input输入的内容联想内容*/
      createACObj () {
        this._AC = new BMap.Autocomplete({ 'input': this.suggestId, 'location': this.BMap })
        this._AC.addEventListener('onconfirm', (e) => {    //鼠标点击下拉列表后的事件
          let _value = e.item.value
          //根据点击返回值修改门店名称
          this.$emit('setStoreTitle', _value.business)
          let myValue = _value.province + _value.city + _value.district + _value.street + _value.business
          let local = new BMap.LocalSearch(this.BMap, { //智能搜索
            onSearchComplete: () => {
              let localData = local.getResults().getPoi(0).point    //获取第一个智能搜索的结果
              let searchPoint = new BMap.Point(localData.lng, localData.lat)
              this.BMap.panTo(searchPoint)
              this._defaultMaker.setPosition(searchPoint)
              this.$emit('onConfirm', { lng: localData.lng, lat: localData.lat })
              this.$emit('dragMarker', { lng: localData.lng, lat: localData.lat })
            }
          })
          local.search(myValue)
        })
      },
      /*将地址转换为经纬度*/
      setAddressToPoint () {
        let myGeo = new BMap.Geocoder();
        let address = this.MapArea.province + this.handleCity(this.MapArea.city) + this.MapArea.district + this.MapArea.address;
        console.log(address)
        myGeo.getPoint(address, point => {
          if (point) {
            this.$emit('setAddToPoint', { lng: point.lng, lat: point.lat })
            this.$emit('dragMarker', { lng: point.lng, lat: point.lat })
            if(this.markPoint[0].nid){
              point=this.markPoint[0];
            }
            this.BMap.panTo(point);
            //清除已有覆盖物
            this.BMap.clearOverlays()
            //创建新的maker,这里主要是单maker传入时根据地址变更改变maker的位置
            this.markPointFun([{
              ...this.markPoint[0],
              ...point
            }]);
            this._defaultMaker.setPosition(point)
          }
        }, "北京市")
      },
      handleCity(name) {
        if (!name) return name
        return name.slice(-1) === '市' ? name : name + '市'
      }
    },
  }
</script>
